import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { getCompanyBrandingList,addCompanyBranding} from '../action/companyBrandingAction';
import CompanyBrandingComponent from '../components/companyBrandingComponent';

export class CompanyBrandingContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getCompanyBrandingList();
    }
    getCompanyBrandingData1 = () =>{
        this.props.actions.getCompanyBrandingList( this.props.dispatch)
    }
    addCompanyBranding = (payload) =>{
        this.props.actions.addCompanyBranding(
            payload,
            this.props.dispatch
        )
    }
    render(){
        return(
            <CompanyBrandingComponent
                getCompanyBrandingData = {this.props.companyBrandingData}
                addCompanyBranding = {this.addCompanyBranding}
                GetCompanyBrandingData = {this.getCompanyBrandingData1}
            >
            </CompanyBrandingComponent>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getCompanyBrandingList,
            addCompanyBranding
        },
            dispatch)
    };
}
function mapStateToProps({ CompanyBrandingReducer }) {
    console.log(CompanyBrandingReducer);
    return {
        companyBrandingData : {
            errorCode : CompanyBrandingReducer.errorCode,
            statusCode : CompanyBrandingReducer.statusCode,
            Message : CompanyBrandingReducer.Message,
            isLoading : CompanyBrandingReducer.isLoading,
            brandList: CompanyBrandingReducer.brandList
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyBrandingContainer));
